export default __webpack_public_path__ + "static/media/search.21e9d6e4.svg";